export function projectFilterModal(root = document, lenis) {
    const archive = root.querySelector('.project-archive');
    const dialog = archive?.querySelector('.project-filter-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const trigger = archive.querySelector('[data-project-filters-open]');
    const count = trigger.querySelector('[data-project-filter-count]');
    const home = archive.querySelector('.project-archive__filters');
    const chips = home.querySelector('.filter-chips');
    const slot = dialog.querySelector('[data-project-filter-options]');
    const sheet = dialog.querySelector('.project-filter-sheet');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let animation;
    let closing = false;
    let previousOverflow;

    const isMobile = () => getComputedStyle(trigger.parentElement).display !== 'none';
    const animate = (opening) => {
        // Read the current position before cancelling, including a partial opening.
        const styles = getComputedStyle(sheet);
        const from = opening ? 'translate3d(0, 100%, 0)' : styles.transform;
        const duration = styles.getPropertyValue('--filter-sheet-duration').trim();
        const easing = styles.getPropertyValue('--filter-sheet-easing').trim();
        const durationMs = parseFloat(duration) * (duration.endsWith('ms') ? 1 : 1000);
        animation?.cancel();
        animation = sheet.animate([
            { transform: from },
            { transform: `translate3d(0, ${opening ? '0' : '100%'}, 0)` }
        ], {
            duration: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : durationMs,
            easing,
            fill: 'both'
        });
        return animation.finished;
    };
    const finishClose = () => {
        if (dialog.open) dialog.close();
        animation?.cancel();
        animation = undefined;
        closing = false;
        trigger.setAttribute('aria-expanded', 'false');
        if (previousOverflow !== undefined) {
            document.documentElement.style.overflow = previousOverflow;
            previousOverflow = undefined;
            lenis?.start();
        }
    };
    const close = () => {
        if (!dialog.open || closing) return;
        closing = true;
        animate(false).then(() => {
            finishClose();
            if (isMobile()) trigger.focus({ preventScroll: true });
        }).catch(() => {});
    };

    trigger.addEventListener('click', () => {
        if (dialog.open || !isMobile()) return;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        lenis?.stop();
        dialog.showModal();
        // Keep focus-induced scrolling out of the outer dialog on mobile browsers.
        dialog.scrollTop = 0;
        trigger.setAttribute('aria-expanded', 'true');
        animate(true).catch(() => {});
    }, options);
    dialog.querySelectorAll('[data-project-filters-close]').forEach(button => {
        button.addEventListener('click', close, options);
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, options);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); }, options);
    chips.addEventListener('click', () => {
        const selected = chips.querySelectorAll('.is-active').length;
        count.hidden = !selected;
        count.textContent = selected ? `(${selected})` : '';
    }, options);

    const syncLayout = () => {
        if (isMobile()) {
            if (chips.parentElement !== slot) slot.append(chips);
        } else {
            finishClose();
            if (chips.parentElement !== home) home.append(chips);
        }
    };
    archive.classList.add('has-mobile-filters');
    syncLayout();
    window.addEventListener('resize', syncLayout, options);

    return () => {
        controller.abort();
        finishClose();
        home.append(chips);
        archive.classList.remove('has-mobile-filters');
    };
}
